import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';
import styled from 'styled-components/native';
import { Card, type CardProps } from './Card';

export type FlatCardProps = CardProps & { backgroundColor?: BACKGROUND_COLORS_VALUES };

export const FlatCard = styled(Card)<FlatCardProps>`
  box-shadow: 0 0 0 transparent;
  border: none;
  background-color: ${({ backgroundColor }) => backgroundColor || COLORS.BACKGROUND_COLORS.PRIMARY_LIGHTEST};
`;
